// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"26b6d1b5","197":"1103fd39","220":"15969bfe","723":"caebc10a","789":"61720cee","835":"6bd26e74","865":"bcd8bcd7"}[chunkId] + ".chunk.js";
};